module.exports={

   /* =================================================== */
       URL:'https://test-services.smartreads.in/noton/graphql',
       Auth:'https://test-services.smartreads.in/identity/oauth/token',
       // networkStatusUrl:'http://localhost:3000/app/'

} 
